import type {
	FollowUpObject,
	StreamError,
	TokenUsageData,
} from '../api/AssistantService/StreamMessage';

/**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-29941 Internal documentation for deprecation (no external access)}. Please use `ConvoAIResponseState` instead.
 * more info: https://hello.atlassian.net/wiki/spaces/CONVAI/pages/4886462722/Sunsetting+assistance-service+timeline
 */
export enum AIAgentResponseState {
	Initialization = 'Initialization',
	AnswerPart = 'AnswerPart',
	FinalResponse = 'FinalResponse',
	FollowUp = 'FollowUp',
	Error = 'Error',
}

type MetaData = {
	tokenData?: TokenUsageData;
};

/**
 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-29941 Internal documentation for deprecation (no external access)}. Please use `ConvoAIStreamingState` instead.
 * more info: https://hello.atlassian.net/wiki/spaces/CONVAI/pages/4886462722/Sunsetting+assistance-service+timeline
 */
export type AIAgentStreamingState<TContent = string> =
	| {
			responseState: AIAgentResponseState.Initialization;
			content: TContent | null;
			answerChunkIndex?: number;
			error?: StreamError;
			followUpContent?: FollowUpObject[];
			metadata?: MetaData;
	  }
	| {
			responseState: AIAgentResponseState.AnswerPart;
			content: TContent;
			answerChunkIndex: number;
			error?: StreamError;
			followUpContent?: FollowUpObject[];
			metadata?: MetaData;
	  }
	| {
			responseState: AIAgentResponseState.FinalResponse;
			content: TContent;
			answerChunkIndex?: number;
			error?: StreamError;
			followUpContent?: FollowUpObject[];
			metadata: MetaData;
	  }
	| {
			responseState: AIAgentResponseState.FollowUp;
			content: TContent | null;
			answerChunkIndex?: number;
			error?: StreamError;
			followUpContent: FollowUpObject[];
			metadata?: MetaData;
	  }
	| {
			responseState: AIAgentResponseState.Error;
			content: TContent | null;
			answerChunkIndex?: number;
			error: StreamError;
			followUpContent?: FollowUpObject[];
			metadata?: MetaData;
	  };

export function getDefaultAIAgentStreamingState<
	TAIAgentStreamingRequest,
>(): AIAgentStreamingState<TAIAgentStreamingRequest> {
	return {
		content: null,
		responseState: AIAgentResponseState.Initialization,
	};
}
